import { render, staticRenderFns } from "./MainTitle.vue?vue&type=template&id=fba697be&scoped=true&"
import script from "./MainTitle.vue?vue&type=script&lang=js&"
export * from "./MainTitle.vue?vue&type=script&lang=js&"
import style0 from "./MainTitle.vue?vue&type=style&index=0&id=fba697be&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fba697be",
  null
  
)

export default component.exports